import { Box } from '@mui/material'
import CustomText from 'components/common/CustomText/CustomText'
import React from 'react'
import { colors } from 'styles/colors'
import useGlobalStyles from 'styles/globalStyles'

interface Props {
  item: any
  index: number;
}

export default function NoteItem({ item, index }: Props) {
  const globalStyles = useGlobalStyles();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={1}
      borderRadius="10px"
      border={`1px solid ${colors.itemBorder}`}
    >
      <Box p={0.5}>
        <CustomText text={`Note ${index + 1}`} color={colors.primary} fontWeight={600} fontSize={14}/>
        <CustomText text={item.note} color={colors.black} />
      </Box>
    </Box>
  )
}
